import {BUSCAR_DESCONTO_USUARIO_ROTA } from '../../actions/types'

const initialState = null

export default function reducerDescontosUsuarioRota (state = initialState, action) {
  switch (action.type) {
    case BUSCAR_DESCONTO_USUARIO_ROTA: {
      const descontos = action.payload.data;

      if (descontos) {
        return descontos
      }
      return []
    }

    default: {
      return state
    }
  }
}
